import { GangResponseDto } from '@operations/app/api'
import { GangUpsertedPayload } from '@operations/app/api/signalRDtos/gangUpsertedPayload'
import { IGangFormData } from '@operations/features/gang/models/gang.model'
import { EventTypes } from '@operations/messages/eventsTypes'
import gangService from '@operations/services/gangService'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'
import { BaseEntityStore } from './base/BaseEntityStore'

export class GangStore extends BaseEntityStore<GangResponseDto> {
  fetchedAll = false
  selectedGang: GangResponseDto | undefined

  constructor(private readonly messageBus: IMessageBus) {
    super()

    makeObservable(this, {
      fetchedAll: observable,
      selectedGang: observable,

      setSelectedGang: action,

      gangNames: computed,
    })

    this.messageBus.subscribeEvent<GangUpsertedPayload>(
      EventTypes.GangUpserted,
      this.handleGangUpsertedEvent,
    )

    this.messageBus.subscribeEvent<number[]>(EventTypes.GangDeleted, this.handleGangDeletedEvent)
  }

  public setSelectedGang(gang: GangResponseDto | undefined) {
    this.selectedGang = gang
  }

  public get gangNames(): string[] {
    return this.items.filter(i => i !== this.selectedGang).map(gang => gang.name)
  }

  public async fetchData() {
    if (this.fetchedAll) return

    const gangs = await gangService.load()

    this.updateStoreItems(gangs)

    runInAction(() => {
      this.fetchedAll = true
    })
  }

  public async updateGang(formData: IGangFormData) {
    await gangService.update({
      ...formData,
    })
  }

  public async createGang(formData: IGangFormData) {
    await gangService.create({
      ...formData,
    })
  }

  public async deleteGangs(ids: number[]) {
    if (!ids || ids.length === 0) return

    await gangService.delete(ids)
  }

  private readonly handleGangUpsertedEvent = (res: IEvent<GangUpsertedPayload>) => {
    if (!res.payload) return
    this.updateStoreItem(res.payload, res.payload.id)
  }

  private readonly handleGangDeletedEvent = (res: IEvent<number[]>) => {
    if (!res.payload) return
    this.deleteStoreItems(res.payload)
  }
}
